export const musicLevels = [
  { name: 'Very High', _id: 'very high' },
  { name: 'High', _id: 'high' },
  { name: 'Medium', _id: 'medium' },
  { name: 'Low', _id: 'low' },
  { name: 'Very Low', _id: 'very low' },
];

export const gameType = [
  { name: 'Single Attempt', _id: 'single attempt' },
  { name: 'Multiple Attempts', _id: 'multiple attempt' },
];

export const gameAnswerType = [
  { name: 'Single', _id: 'single' },
  { name: 'Multiple', _id: 'multiple' },
];

export const classificationGameType = [
  { name: 'Splits Game', _id: 'splits game' },
  { name: 'Multiple', _id: 'multi category' },
];

export const classificationType = [
  { name: 'Text', _id: 'text' },
  { name: 'Image', _id: 'image' },
];

export const sjtType = [
  { name: 'Questions', _id: 'Questions' },
  { name: 'Sequences', _id: 'Sequences' },
  { name: 'Jumbles', _id: 'Jumbles' },
  { name: 'Mini Game', _id: 'MiniGames' },
  { name: 'Branches', _id: 'Branches' },
  { name: 'Password Game', _id: 'PasswordGames' },
];

export const scoringMechanismType = [
  { name: 'Addition', value: 'addition' },
  { name: 'Passthrough', value: 'passthrough' },
];

export const masterGameTypes = [
  { name: 'Questions Game', _id: 'QuestionsGame' },
  { name: 'Jumbles Game', _id: 'JumblesGame' },
  { name: 'Orderings Game', _id: 'OrderingsGames' },
  { name: 'SJT Game', _id: 'SJTGame' },
  { name: 'Classification Game', _id: 'ClassificationGame' },
  { name: 'MatchColumn Game', _id: 'MatchColumnGame' },
  { name: 'Mini Game', _id: 'MiniGames' },
  { name: 'Password Game', _id: 'PasswordGames' },
  { name: 'Video', _id: 'Videos' },
  { name: 'Pdf', _id: 'Pdf' },
  { name: 'File', _id: 'File' },
  { name: 'Wheel Game', _id: 'WheelSpinGame' },
  { name: 'Mario Game', _id: 'MarioGame' },
  { name: 'Packing Game', _id: 'PackingGame' },
  { name: 'Monopoly Turn Game', _id: 'MonopolyTurnGame' },
  { name: 'Angry Bird Game', _id: 'AngryBirdGame' },
  { name: 'Slider Game', _id: 'SliderGame' },
  { name: 'Bubble Shooter Game', _id: 'BubbleShooterGame' },
  { name: 'Stick Cricket Game', _id: 'StickCricketGame' },
  { name: 'Fire Pilot Game', _id: 'FirePilotGame' },
  { name: 'Fruit Ninja Game', _id: 'FruitNinjaGame' },
  { name: 'Maze Game', _id: 'MazeGame' },
  { name: 'Pool Game', _id: 'PoolGame' },
  { name: 'Racing Game', _id: 'RacingGame' },
  { name: 'Pipe Puzzle Game', _id: 'PathFinderGame' },
  { name: 'Spot On Game', _id: 'SpotOnGame' },
  { name: 'Snake Ladder Game', _id: 'SnakeLadderGame' },
  { name: 'Para Drop Game', _id: 'ParadropGame' },
  { name: 'Straight Shooter Game', _id: 'StraightShooterGame' },
  { name: 'Words Puzzle', _id: 'WordsPuzzleGame' },
];

export const hintImagesGamesType = [
  { name: 'Questions Game', _id: 'QuestionGame' },
  { name: 'Jumbles Game', _id: 'JumblesGame' },
  { name: 'Orderings Game', _id: 'OrderingGame' },
  { name: 'SJT Game', _id: 'SJTGame' },
  { name: 'Classification Game', _id: 'ClassificationGame' },
  { name: 'MatchColumn Game', _id: 'MTCGame' },
];

export const domainType = [
  { name: 'Sales', _id: 'sales' },
  { name: 'Marketing', _id: 'marketing' },
  { name: 'IT', _id: 'it' },
  { name: 'Operations', _id: 'operations' },
  { name: 'Finance', _id: 'finance' },
  { name: 'All', _id: 'all' },
];
// eslint-disable-next-line @typescript-eslint/naming-convention
export const REFRESH_TIME_IN_MINUTES = 10;

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DEFAULT_Y_CORD = 50000;

export const paginationPosition = {
  top: 'top',
  both: 'both',
};

export const languageOptions = [
  { code: 'hi', name: 'Hindi' },
  { code: 'mr', name: 'Marathi' },
  { code: 'gu', name: 'Gujarati' },
  { code: 'ml', name: 'Malayalam' },
  { code: 'en', name: 'English' },
  { code: 'pa', name: 'Punjabi' },
  { code: 'bn', name: 'Bengali' },
  { code: 'or', name: 'Odia' },
  { code: 'as', name: 'Assamese' },
  { code: 'ta', name: 'Tamil' },
  { code: 'te', name: 'Telugu' },
  { code: 'kn', name: 'Kannada' },
];

// Maps a language code (e.g. 'hi') to its display name (e.g. 'Hindi').
export const languageNameByCode: Record<string, string> = languageOptions.reduce(
  (acc, language) => ({ ...acc, [language.code]: language.name }),
  {},
);
